import React, { useState } from 'react'
import {
    ViewGridIcon,
    MenuIcon,
    UserIcon,
    HomeIcon,
    LogoutIcon,
    UserGroupIcon
} from '@heroicons/react/outline'
import {
    Link
} from 'react-router-dom';
import { useAuth } from "../../hooks/auth";

const menu = [
  { title: 'Dashboard', path: '/app/dashboard', icon:ViewGridIcon },
  { title: 'Works',     path: '/app/work', icon:MenuIcon },
  { title: 'Composers', path: '/app/composer', icon:UserGroupIcon },
  { title: 'Profil ',   path: '/app/profil', icon:UserIcon },
  { title: 'Go home ',  path: '/', icon:HomeIcon }
];


const Sidebar = (props) => {

 const [showSideNav, setShowSideNav] = useState(false);

 const { logout } = useAuth();
 
  return (
    <div>
        <nav className="bg-white border-b border-gray-200 z-30 w-full">
            <div className="px-3 py-3 lg:px-5 lg:pl-3">
                <div className="flex items-center justify-between">
                    <div className="flex items-center justify-start">
                        <button onClick={()=>setShowSideNav(!showSideNav)} id="toggleSidebarMobile" ariaExpanded="true" ariaControls="sidebar" className="lg:hidden mr-2 text-gray-600 hover:text-gray-900 cursor-pointer p-2 hover:bg-gray-100 focus:bg-gray-100 focus:ring-2 focus:ring-gray-100 rounded z-50">
                            {!showSideNav&&
                            <svg id="toggleSidebarMobileHamburger" className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd"></path>
                            </svg>
                            }
                            {showSideNav&&
                            <svg id="toggleSidebarMobileClose" className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path>
                            </svg>
                            }
                        </button>
                        <Link to="/" className="hidden text-xl font-bold flex items-center lg:ml-2.5"> 
                            <>
                            <span className="self-center text-pgray whitespace-nowrap">oPPDb </span>
                            </>
                        </Link>
                        
                    </div>
                    <div className="flex items-center">
                        
                    </div>
                </div>
            </div>
        </nav>
        <div className="flex overflow-hidden bg-white pt-0">
        <aside id="sidebar" className={`${showSideNav? '' : ' hidden '}${" fixed z-20 h-full top-0 left-0 pt-16 flex lg:flex flex-shrink-0 flex-col w-64 transition-width duration-75"}`} ariaLabel="Sidebar">
            <div className="relative flex-1 flex flex-col min-h-0 bg-white mt-16 md:mt-16 shadow-2xl md:shadow-lg">
                <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
                    <div className="flex-1 px-0 bg-white divide-y space-y-1 mt-0">
                        <ul className="space-y-4 pb-2">
                            {menu.map((item, index) => (
                                <Link key={index} to={item.path}>
                                    <li className="cursor-pointer">
                                        <a 
                                        className={`flex items-center px-8 py-2 py-3 transition duration-100 ease-in-out hover:bg-pblue ${
                                            window.location.pathname === item.path
                                            ? 'bg-pblue border-r-4 border-pblue text-white'
                                            : 'text-black'
                                        }`}
                                        >
                                            <item.icon className="flex-shrink-0 h-6 w-6 text-gray-500 mt-0 mr-2" aria-hidden="true" />
                                            <span className="ml-3 flex-1 whitespace-nowrap"> {item.title}</span>
                                        </a>
                                    </li>
                                </Link>
                                )
                            )}
                            <a onClick={()=>logout()}>
                                <li className="cursor-pointer">
                                    <a 
                                    className={`flex items-center px-8 py-2 py-3 text-black transition duration-100 ease-in-out hover:bg-pblue`}
                                    >
                                    <LogoutIcon className="flex-shrink-0 h-6 w-6 text-gray-500 mt-0 mr-2" aria-hidden="true" />
                                    <span className="ml-3 flex-1 whitespace-nowrap"> Sign out</span>
                                    </a>
                                </li>
                            </a>
                        </ul>
                    </div>
                </div>
            </div>
        </aside>
        <div className="bg-gray-900 opacity-50 hidden fixed inset-0 z-10" id="sidebarBackdrop"></div>
            <div id="main-content" className="h-full w-full bg-gray-50 relative overflow-y-auto lg:ml-64">
                <main>
                    <div className="px-4 mt-6 h-screen overflow-y-auto">
                        {props.children}
                    </div>
                </main>
            </div>
        </div>
    </div>
  )
}
export default React.memo(Sidebar);
